export const classNames = (...classes: (string | undefined | null | false)[]): string => {
  return classes.filter(Boolean).join(' ');
};

export const conditionalClass = (condition: boolean, trueClass: string, falseClass?: string): string => {
  return condition ? trueClass : (falseClass || '');
};

export const variantClass = <T extends string>(
  variant: T,
  variants: Record<T, string>,
  defaultVariant?: T
): string => {
  return variants[variant] || (defaultVariant ? variants[defaultVariant] : '');
};